<template>
    <svg
        v-if="outline"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 17.9196 4.45074 19.734 5.25215 21.343C5.46512 21.7706 5.53601 22.2593 5.41254 22.7207L4.69781 25.392C4.38754 26.5516 5.44842 27.6125 6.60802 27.3022L9.27926 26.5875C9.74072 26.464 10.2294 26.5349 10.657 26.7478C12.266 27.5493 14.0804 28 16 28Z"
            stroke="currentColor"
            :stroke-width="strokeWidth"
        />
        <path
            d="M11.2 14.2002H20.8"
            stroke="currentColor"
            :stroke-width="strokeWidth"
            stroke-linecap="round"
        />
        <path
            d="M11.2 18.3999H17.8"
            stroke="currentColor"
            :stroke-width="strokeWidth"
            stroke-linecap="round"
        />
    </svg>
    <svg
        v-else
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 17.9196 4.45074 19.734 5.25215 21.343C5.46512 21.7706 5.53601 22.2593 5.41254 22.7207L4.69781 25.392C4.38754 26.5516 5.44842 27.6125 6.60802 27.3022L9.27926 26.5875C9.74072 26.464 10.2294 26.5349 10.657 26.7478C12.266 27.5493 14.0804 28 16 28Z"
            fill="currentColor"
            stroke="currentColor"
            :stroke-width="strokeWidth"
        />
        <path
            d="M11.2 14.2002H20.8"
            stroke="#619B23"
            :stroke-width="strokeWidth"
            stroke-linecap="round"
        />
        <path
            d="M11.2 18.3999H17.8"
            stroke="#619B23"
            :stroke-width="strokeWidth"
            stroke-linecap="round"
        />
    </svg>
</template>

<script>
export default {
    name: "CommentIcon",
    props: {
        outline: {
            type: Boolean,
            default: true,
        },
        strokeWidth: {
            type: String,
            default: "1.2",
        },
    },
    setup() {
        return {};
    },
};
</script>
